var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5C6 3.89543 6.89543 3 8 3H28C29.1046 3 30 3.89543 30 5V7H32C33.1046 7 34 7.89543 34 9V35C34 36.1046 33.1046 37 32 37H12C10.8954 37 10 36.1046 10 35V33H8C6.89543 33 6 32.1046 6 31V5ZM12 33V35H32V9H30V31C30 32.1046 29.1046 33 28 33H12ZM19 5L8 5V31H28V5H26V12C26 12.3844 25.7797 12.7348 25.4332 12.9013C25.0867 13.0678 24.6755 13.021 24.3753 12.7809L22.5 11.2806L20.6247 12.7809C20.3245 13.021 19.9133 13.0678 19.5668 12.9013C19.2203 12.7348 19 12.3844 19 12V5ZM21 5V9.91937L21.8753 9.21913C22.2405 8.92696 22.7595 8.92696 23.1247 9.21913L24 9.91937V5H21ZM10 8C10 7.44772 10.4477 7 11 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H11C10.4477 9 10 8.55228 10 8ZM10 12C10 11.4477 10.4477 11 11 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H11C10.4477 13 10 12.5523 10 12ZM10 16C10 15.4477 10.4477 15 11 15H25C25.5523 15 26 15.4477 26 16C26 16.5523 25.5523 17 25 17H11C10.4477 17 10 16.5523 10 16ZM10 20C10 19.4477 10.4477 19 11 19H25C25.5523 19 26 19.4477 26 20C26 20.5523 25.5523 21 25 21H11C10.4477 21 10 20.5523 10 20ZM10 24C10 23.4477 10.4477 23 11 23H25C25.5523 23 26 23.4477 26 24C26 24.5523 25.5523 25 25 25H11C10.4477 25 10 24.5523 10 24ZM10 28C10 27.4477 10.4477 27 11 27H25C25.5523 27 26 27.4477 26 28C26 28.5523 25.5523 29 25 29H11C10.4477 29 10 28.5523 10 28Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWill);
export default __webpack_public_path__ + "static/media/will.963b8e75a1823decc062dcc8d3fae529.svg";
export { ForwardRef as ReactComponent };